import Accordion from 'accordion-js'

export function accordion() {
	const accordion = Array.from(document.querySelectorAll('.accordion'))
	return new Accordion(accordion, {
		duration: 400,
		showMultiple: true
	})
}
